export const GUID_REGEXP = /[0-9A-Fa-f]{8}(?:-[0-9A-Fa-f]{4}){3}-[0-9A-Fa-f]{12}/;

export const ADDRESS_FULL_FLAT_REGEXP = /,\s*кв.*$/;

// Регулярка для информации о квартире (сокращённо «кв» с номером или без)
export const ADDRESS_APARTMENT_REGEXP = /,\s*кв\.?\s*\d+\s*[a-zа-яё]*$/i;

export const ADDRESS_FLAT_REGEXP = /,\s?кв\.?\s?/;
export const ADDRESS_POSTAL_CODE_REGEXP = /^\d{6},*\s/;
